import React, { useContext, useMemo } from "react";
import { Button } from "antd";
import classNames from "classnames";
import { GlobalContext } from "contexts/GlobalContext";
import {
  EMPTY_SHORTCUTS,
  SHORTCUT_BTN_CLASS,
  SHORTCUT_GAP_STYLE,
  groupsBelowRow1,
  shouldShowShortcutGroups,
} from "helpers/Pricer/addOptionShortcuts";

function shortcutBtnClass(darkTheme, selected) {
  return classNames(SHORTCUT_BTN_CLASS, {
    "ant-btn-dark": darkTheme,
    "add-option-shortcuts__btn--selected": selected,
  });
}

function ShortcutButton({ item, selectedValue, darkTheme, onSelect }) {
  return (
    <Button
      className={shortcutBtnClass(darkTheme, item?.value === selectedValue)}
      onClick={() => onSelect(item)}
    >
      {item.label}
    </Button>
  );
}

function WrappingShortcutRow({ items, ...buttonProps }) {
  return (
    <div className="add-option-shortcuts__wrap">
      {items.map((item) => (
        <ShortcutButton key={item.value} item={item} {...buttonProps} />
      ))}
    </div>
  );
}

function NowrapShortcutRow({ items, ...buttonProps }) {
  return (
    <div className="add-option-shortcuts__row1">
      {items.map((item) => (
        <ShortcutButton key={item.value} item={item} {...buttonProps} />
      ))}
    </div>
  );
}

function GroupedShortcuts({ groups, ...listProps }) {
  return (
    <>
      <div className="add-option-shortcuts__divider" role="separator" />
      <div className="add-option-shortcuts__groups">
        {groups.map((group) => (
          <section key={group.name} className="add-option-shortcuts__group">
            <h3 className="add-option-shortcuts__group-name">{group.name}</h3>
            <WrappingShortcutRow items={group.items} {...listProps} />
          </section>
        ))}
      </div>
    </>
  );
}

function ShortcutButtons({ shortcuts, selectedValue, onSelect }) {
  const {
    globalState: { dark_Theme },
  } = useContext(GlobalContext);
  const suggested = shortcuts?.suggested ?? EMPTY_SHORTCUTS.suggested;
  const groups = shortcuts?.groups ?? EMPTY_SHORTCUTS.groups;

  const visibleGroups = useMemo(
    () => groupsBelowRow1(groups, suggested),
    [groups, suggested]
  );

  const listProps = {
    selectedValue,
    darkTheme: dark_Theme,
    onSelect,
  };
  const showGroups = shouldShowShortcutGroups(visibleGroups);

  return (
    <div className="add-option-shortcuts" style={SHORTCUT_GAP_STYLE}>
      <div className="add-option-shortcuts__list">
        <NowrapShortcutRow items={suggested} {...listProps} />
        {showGroups ? (
          <GroupedShortcuts groups={visibleGroups} {...listProps} />
        ) : null}
      </div>
    </div>
  );
}

export default ShortcutButtons;
